class MetaobjectForm extends HTMLElement {
  constructor() {
    super();
    // DOM refs (set in connectedCallback)
    this.brandSelect = null;
    this.modelSelect = null;
    this.grindSizeDisplay = null;

    // Data store
    this.data = [];

    // External UI scope
    this.sectionContainer = null;
  }

  connectedCallback() {
    const sectionId = this.getAttribute('data-section-id');

    // Scope queries to this section container to avoid cross-section bleed
    this.sectionContainer =
      document.querySelector(`#shopify-section-${sectionId}`) ||
      document.querySelector(`#grind-selector-wrap-${sectionId}`) ||
      this.closest('[id^="shopify-section-"]') ||
      document;

    // Internal fields inside the custom element
    this.brandSelect = this.querySelector('#brand');
    this.modelSelect = this.querySelector('#model');
    this.grindSizeDisplay = this.querySelector('#grindSize');

    // Parse JSON from <script type="application/json"> tag
    const dataNode = document.getElementById(`metaobjectData-${sectionId}`);
    this.data = this._safeParseArray(dataNode?.textContent);

    // Initial populate
    this.resetSelects();
    this.populateBrands();

    // Events
    this.brandSelect.addEventListener('change', this.handleBrandChange.bind(this));
    this.modelSelect.addEventListener('change', this.handleModelChange.bind(this));
  }

  // Robust parser: supports {data:[...]} or [...] shapes
  _safeParseArray(text) {
    if (!text) return [];
    try {
      const obj = JSON.parse(text);
      if (Array.isArray(obj)) return obj;
      if (Array.isArray(obj?.data)) return obj.data;
      // Try common nesting: obj?.grind_settings?.data, etc.
      for (const key of Object.keys(obj || {})) {
        if (Array.isArray(obj[key])) return obj[key];
        if (obj[key] && Array.isArray(obj[key].data)) return obj[key].data;
      }
      return [];
    } catch {
      return [];
    }
  }

  resetSelects() {
    this.brandSelect.innerHTML = '<option value="">Select Brand</option>';
    this.modelSelect.innerHTML = '<option value="">Select Model</option>';
    this.modelSelect.disabled = true;
    this.grindSizeDisplay.textContent = '';
  }

  populateBrands() {
    if (!Array.isArray(this.data)) return;
    const brands = [...new Set(this.data.map(i => i.Brand))].sort();
    brands.forEach(brand => {
      const opt = document.createElement('option');
      opt.value = brand;
      opt.textContent = brand;
      this.brandSelect.appendChild(opt);
    });
  }

  handleBrandChange() {
    const brand = this.brandSelect.value;
    this.modelSelect.innerHTML = '<option value="">Select Model</option>';
    this.grindSizeDisplay.textContent = '';

    if (!brand) {
      this.modelSelect.disabled = true;
      return;
    }

    const models = [...new Set(
      this.data.filter(i => i.Brand === brand).map(i => i.Model)
    )].sort();

    models.forEach(model => {
      const opt = document.createElement('option');
      opt.value = model;
      opt.textContent = model;
      this.modelSelect.appendChild(opt);
    });

    this.modelSelect.disabled = models.length === 0;
  }

  handleModelChange() {
    const brand = this.brandSelect.value;
    const model = this.modelSelect.value;
    this.grindSizeDisplay.textContent = '';

    if (!brand || !model) return;

    const row = this.data.find(i => i.Brand === brand && i.Model === model);
    if (row && Object.prototype.hasOwnProperty.call(row, 'Grind Setting')) {
      this.grindSizeDisplay.textContent = row['Grind Setting'];
    }
  }
}

customElements.define('metaobject-form', MetaobjectForm);

